export const apiConstants = {
  url: "/api/labelorders"
};
